import { InlineBanner } from "components/ui/inline-banner";
import { WhiteLabelContentMode } from "generated/graphql";
import React from "react";
import { useProductName, useWhiteLabelContentMode } from "store/selectors/branding";

const defaultSignwiseFromAddress = "communications@findassistedliving.org";

export const DirectEmailSetupBanner: React.FC = () => {
    const productName = useProductName();
    const contentMode = useWhiteLabelContentMode();

    const fromAddressDescription =
        contentMode === WhiteLabelContentMode.Restricted
            ? "a shared sending address"
            : defaultSignwiseFromAddress;

    return (
        <InlineBanner type="info">
            Your {productName} emails will come from {fromAddressDescription}.
        </InlineBanner>
    );
};
